import React from 'react';
import { Box } from '@mui/material';
import { ChevronRight as ChevronRightIcon } from '@mui/icons-material';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export interface Crumb {
  label: React.ReactNode;
  to?: string;
}

// "Groups › Saigon Runners › October 100K"; the last crumb is the current page.
export const BreadcrumbTrail = ({ items }: { items: Crumb[] }) => {
  const { t } = useTranslation('layout');
  return (
    <Box component="nav" aria-label={t('breadcrumb.ariaLabel')} sx={{ display: 'flex', gap: 0.75, alignItems: 'center', fontSize: 13, color: 'var(--muted)', flexWrap: 'wrap' }}>
      {items.map((c, i) => {
        const last = i === items.length - 1;
        return (
          <React.Fragment key={i}>
            {c.to && !last ? (
              <Box component={RouterLink} to={c.to} sx={{ color: 'var(--muted)' }}>
                {c.label}
              </Box>
            ) : (
              <Box component="span" sx={{ color: last ? 'var(--fg)' : 'var(--muted)' }} aria-current={last ? 'page' : undefined}>
                {c.label}
              </Box>
            )}
            {!last && <ChevronRightIcon sx={{ fontSize: 16 }} />}
          </React.Fragment>
        );
      })}
    </Box>
  );
};
